import { render, staticRenderFns } from "./ContactsListItem.vue?vue&type=template&id=f9ed6af4&"
import script from "./ContactsListItem.vue?vue&type=script&lang=js&"
export * from "./ContactsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports